<template>
  <button
    :class="[
      'rounded-full flex flex-row grow-0 text-white text-center px-[16px] py-[8px]',
      isGICPage() ? 'bg-orange' : 'bg-lightblue',
    ]"
    @click="toggleShowSharing"
  >
    <img
      class="mr-[8px]"
      src="../../../../public/assets/icons/playback-resources/share-icon.svg"
      alt=""
    />
    {{ $t('copy.resourcesPage.videoPage.shareButton') }}
  </button>
</template>

<script>
import { isGICPage } from '@/utils/conference-type';

export default {
  methods: {
    isGICPage,
    toggleShowSharing() {
      this.$emit('toggleSharing');
    },
  },
};
</script>

<style scoped></style>
